import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Driver } from '@/types/driver.ts'
import { axiosClient } from '@/utils/axios-client'

export const useDriversStore = defineStore('carrierDrivers', () => {
  const drivers = ref<Driver[]>([])

  async function fetchAllDriversFromOrganisation() {
    const response = await axiosClient.request<Driver[]>({
      url: '/idf/api/drivers',
      method: 'GET',
    })

    drivers.value = response.data.filter(driver => driver.status)
  }

  return {
    drivers,
    fetchAllDriversFromOrganisation,
  }
})
